module.exports = function (fox) {
	'use strict';

	var require__templates = require.context('fox-dynamic-injection!fox-template-loader!./templates', true, /\.tpl$/);
	var templateFiles = require__templates.keys();

	templateFiles.forEach(function (file) {
		require__templates(file)(fox);
	});

	require('./options/store')(fox);
	require('./stylus/_store.styl');
};



//////////////////
// WEBPACK FOOTER
// ./components/store/index.js
// module id = 505
// module chunks = 4